import { isArray, isString } from "lodash";

import { userModuleRoutes, userPageAccess } from "assets/pageAccess";
import { lStorage } from "./storage";

export const userTypeHasAccess = (routeURL) => {
  let url;
  let hasAccess;
  let userPageAccessList;
  let userTypeList;
  let routes = [];

  const { user_type, role } = lStorage.get("authInfo") || {};
  if (isString(routeURL) && routeURL !== "/") {
    url = routeURL?.replace(/^\/|\/$/g, "");
  } else {
    url = routeURL;
  }

  userTypeList = userPageAccess?.filter((item) => {
    return item.userType === user_type;
  });
  if (userTypeList && isArray(userTypeList) && userTypeList[0]) {
    if (user_type === "U") {
      userPageAccessList = userTypeList[0]?.route?.filter((item) => {
        return item.userRole === role;
      });
      const { includeRoutes, excludeRoutes } = userPageAccessList[0] || {};
      routes = userModuleRoutes?.filter(
        (item) => !excludeRoutes?.includes(item)
      );
      routes = routes?.concat(includeRoutes);
    } else {
      routes = userTypeList[0]?.route;
    }
  }
  if (routes && isArray(routes)) {
    hasAccess = routes.some((route) => {
      const pattern = route?.replace(/(:\w+)/g, "([\\w-]+)");
      const regex = new RegExp(`^${pattern}$`);

      return regex.test(url);
    });
  } else {
    hasAccess = false;
  }

  return hasAccess;
};
